module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page"
    }
  }, [_c('h1', [_vm._v("רשימת פרוייקטים")]), _vm._v(" "), _c('table', {
    staticClass: "center rtl tableWithTools",
    attrs: {
      "align": "center",
      "cellpadding": "10",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("שם "), _c('span', {
    staticClass: "oi",
    attrs: {
      "data-glyph": "arrow-bottom"
    }
  }), _c('span', {
    staticClass: "oi",
    attrs: {
      "data-glyph": "arrow-top"
    }
  })]), _vm._v(" "), _c('th', [_vm._v("כלים")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "oi colorLink isLink",
    attrs: {
      "data-glyph": "link-intact"
    }
  }), _vm._v(" בדיקה אחת שתיים שלוש")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "oi colorWarning isLink",
    attrs: {
      "data-glyph": "pencil"
    }
  }), _vm._v("   "), _c('span', {
    staticClass: "oi colorDanger isLink",
    attrs: {
      "data-glyph": "trash"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "oi colorLink isLink",
    attrs: {
      "data-glyph": "link-intact"
    }
  }), _vm._v(" בדיקה אחת שתיים שלוש")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "oi colorWarning isLink",
    attrs: {
      "data-glyph": "pencil"
    }
  }), _vm._v("   "), _c('span', {
    staticClass: "oi colorDanger isLink",
    attrs: {
      "data-glyph": "trash"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "oi colorLink isLink",
    attrs: {
      "data-glyph": "link-intact"
    }
  }), _vm._v(" בדיקה אחת שתיים שלוש")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "oi colorWarning isLink",
    attrs: {
      "data-glyph": "pencil"
    }
  }), _vm._v("   "), _c('span', {
    staticClass: "oi colorDanger isLink",
    attrs: {
      "data-glyph": "trash"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86e7c6ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Principal.vue
// module id = 207
// module chunks = 1